import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanMatch, Data, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { SnackbarService } from '../service/snackbar.service';
import { FeatureFlagsService } from '../service/feature-flags.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagGuard implements CanActivate, CanMatch {

  constructor(
    private readonly featureFlagsService: FeatureFlagsService,
    private readonly router: Router,
    private readonly snackbarService: SnackbarService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return this.validateAccess(route.data);
  }

  canMatch(route: Route, segments: UrlSegment[]): Promise<boolean | UrlTree> {
    return this.validateAccess(route.data);
  }

  private async validateAccess(routeData?: Data): Promise<boolean | UrlTree> {
    const featureFlagKey = routeData?.requiredFeatureFlagKey;
    if (!featureFlagKey) {
      return true;
    }

    const enabled = await this.featureFlagsService.isEnabled(featureFlagKey, false);
    if (enabled) {
      return true;
    }

    const message = routeData?.featureFlagUnavailableMessage || 'Área indisponível no momento.';
    const fallbackUrl = routeData?.featureFlagFallbackUrl || '/settings';

    this.snackbarService.info(message);
    return this.router.createUrlTree([fallbackUrl]);
  }
}
